module.exports = __webpack_public_path__ + "img/QD.1f99560c.png";